(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  // 定义 StickyHeader 类，继承自 HTMLElement
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    // 当元素被添加到 DOM 时调用
    connectedCallback() {
      // 获取头部元素
      this.header = document.querySelector('.section-header');
      // 判断是否始终粘性或需要缩小 logo
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      // 设置头部高度
      this.setHeaderHeight();

      // 监听窗口大小变化，重新设置头部高度
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // 如果头部始终粘性，添加相应的类
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      // 初始化滚动相关变量
      this.currentScrollTop = 0;
      this.preventReveal = false;
      // 获取预测搜索元素
      this.predictiveSearch = this.querySelector('predictive-search');

      // 绑定滚动事件处理函数
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      // 添加事件监听器
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      // 创建 Intersection Observer
      this.createObserver();
    }

    // 设置头部高度的方法
    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    // 当元素从 DOM 中移除时调用
    disconnectedCallback() {
      // 移除事件监听器
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    // 创建 Intersection Observer 来监测头部位置
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    // 滚动事件处理函数
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      // 如果预测搜索打开，不处理滚动
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // 向下滚动超过头部
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } 
      // 向上滚动但仍在头部下方
      else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } 
      // 滚动到顶部
      else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    // 隐藏头部
    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    // 显示头部
    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    // 重置头部状态
    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // 关闭菜单
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    // 关闭搜索模态框
    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  // 注册自定义元素
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
